import React from 'react'
import ReviewForm from './ReviewForm'
import Reviews from './Reviews'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import Link from 'next/link'
import { useContextElement } from '@/context/Context'
import Styles from '@/components/blogs/BlogDetails.module.css'

const formatVideoUrl = (url) => {
  const reg =
    /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/

  const match = url.match(reg)
  return match ? `https://www.youtube.com/embed/${match[1]}` : null
}

export default function Video({ data }) {
  let videoUrl
  if (data.MediaData[0].MediaType === 'video') {
    videoUrl = formatVideoUrl(data.MediaData[0].PicturePath)
  }

  return (
    <section className="blog-page blog-single container">
      <div className="mw-930">
        <div>
          <span style={{ fontSize: '36px' }} className="page-title">
            {data.ArticleTitle}
          </span>
          <div className="blog-single__item-meta">
            <span className="blog-single__item-meta__date">
              更新日期 : {data.PublishedDateFormatted}
            </span>
            <span className="blog-single__item-meta__date">
              閱讀次數 : {data.ViewCount}
            </span>
          </div>
          <div className="video-container mb-4">
            <div className="ratio ratio-16x9">
              <iframe
                src={videoUrl}
                title={data.ArticleTitle || 'YouTube video player'}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                }}
              ></iframe>
            </div>
          </div>
        </div>

        <span style={{ fontSize: '18px' }}>{data.Description}</span>
      </div>

      {data.Content && data.Content != '' && (
        <>
          <div className="mw-930 mt-4">文章內容</div>
          <div
            className="blog-single__item-content d-flex flex-column align-items-center"
            dangerouslySetInnerHTML={{ __html: data.Content }}
          ></div>
        </>
      )}
    </section>
  )
}
